import { render, staticRenderFns } from "./RelatorioGestaoPcaCdar.vue?vue&type=template&id=0f14673e"
import script from "./RelatorioGestaoPcaCdar.vue?vue&type=script&lang=ts"
export * from "./RelatorioGestaoPcaCdar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports